import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IAgency } from '../interfaces/agency';

@Injectable({
  providedIn: 'root'
})
export class AgencyService {
  private rootUrl: string = "/api/agencies";

  constructor(private httpClient: HttpClient) { }

  public getAgencyAdminAgencies(username: string, appId: number, agencyTypeId: number | null): Observable<IAgency[]> {
    var url = this.rootUrl + "/agency-admin?username=" + username + "&appId=" + appId;
    if (agencyTypeId)
      url = url + "&agencyTypeId=" + agencyTypeId;
    return this.httpClient.get<IAgency[]>(url);
  }
}
